import Icon from '../components/Icon.vue'

Icon.register({
  'closed-captioning': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M464 64H48C21.5 64 0 85.5 0 112V400C0 426.5 21.5 448 48 448H464C490.5 448 512 426.5 512 400V112C512 85.5 490.5 64 464 64zM218.1 287.7C220.9 285.2 225.2 285.6 227.3 288.6L246.8 316.3C248.5 318.7 248.3 321.9 246.3 324 192.7 380.8 73.5 356.1 73.5 256.1 73.5 158.8 195.2 136.6 246 186 248.1 188 248.5 189.2 247 191.7L229.5 222.2C227.6 225.3 223.3 226.2 220.4 223.9 179.6 191.9 125.8 209 125.8 255.1 125.9 303.1 176.9 325.6 218.1 287.7zM408.5 287.7C411.3 285.2 415.6 285.6 417.7 288.6L437.2 316.3C438.9 318.7 438.7 321.9 436.7 324 383.2 380.9 264 356.1 264 256.1 264 158.8 385.7 136.6 436.5 186 438.6 188 439 189.2 437.5 191.7L420 222.2C418.1 225.3 413.8 226.2 410.9 223.9 370.1 191.9 316.3 209 316.3 255.1 316.3 303.1 367.3 325.6 408.5 287.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/closed-captioning.js
// module id = O7Ew
// module chunks = 144